import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { executionLogStateSelector } from "./executionLogStateSelector";

export const executionLogFiltersSelector = createDraftSafeSelector(
  [executionLogStateSelector],
  (executionLogState) => {
    return executionLogState.filters;
  },
);
